import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTTransmutationABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_TRANSMUTATION_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, NFT_TRANSMUTATION_ADDRESS);
  if (!contractReader) throw new Error("Failed to create nft-manager contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_TRANSMUTATION_ADDRESS);
  if (!contractSender) throw new Error("Failed to create nft-manager contract sender");
  return contractSender;
}

async function getTransmuteFee(rarity) {
  const res = await getContractReader().methods.getTransmuteFee(rarity).call();
  return res;
}

async function getForgingLengthOfOwner(accountAddress) {
  const res = await getContractReader().methods.getForgingLengthOfOwner(accountAddress).call();
  return parseInt(res);
}
async function getForgingIdOfOwnerAtIndex(accountAddress, index) {
  const tokenId = await getContractReader().methods.getForgingIdOfOwnerAtIndex(accountAddress, index).call();
  return parseInt(tokenId);
}

async function getRemainingTime(transmuteId) {
  const remainingTime = await getContractReader().methods.getRemainingTime(transmuteId).call();
  return parseInt(remainingTime);
}

async function claimTransmute(dispatch, tokenId, accountAddress, onTxHash = () => {}) {
  const emit = getContractSender().methods.claimTransmute(tokenId).send({ from: accountAddress });
  emit.on("transactionHash", onTxHash);
  handleEmit(dispatch, emit, "Claim NFT");
  const res = await emit;
  if (res["logs"]) {
    const correctLogs = res["logs"].find(
      (_log) => _log["topics"][0].toLowerCase() == "0x06181a9e0fec76413c9baa3db7a89047c2a7ee822fe562e39bbe620c0d7b80e5"
    );
    if (correctLogs) {
      const transaction = web3Reader.eth.abi.decodeLog(
        [
          {
            indexed: false,
            internalType: "address",
            name: "claimant",
            type: "address",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "transmuteId",
            type: "uint256",
          },
        ],
        correctLogs.data,
        ["0x06181a9e0fec76413c9baa3db7a89047c2a7ee822fe562e39bbe620c0d7b80e5"]
      );
      return { status: "success", tokenTransmuted: parseInt(transaction.transmuteId) };
    }
  }
  throw new Error("Event not found");
  // if (res.events.TransmuteClaimed) {
  //   const event = res.events.TransmuteClaimed;
  //   return { status: "success", tokenTransmuted: parseInt(event.returnValues.transmuteId) };
  // } else throw new Error("Event not found");
}

async function transmute(dispatch, tokenIds, type, rarity, targetType, accountAddress) {
  const emit = getContractSender().methods.transmute(tokenIds, type, rarity, targetType).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Transmutation NFT");
  const res = await emit;
  if (res["logs"]) {
    const correctLogs = res["logs"].find(
      (_log) => _log["topics"][0].toLowerCase() == "0xd7eaad220666ecc923d59708f4957538e7c552dce8abf6c8ab6f833e558b892c"
    );
    if (correctLogs) {
      const transaction = web3Reader.eth.abi.decodeLog(
        [
          {
            indexed: false,
            internalType: "uint256[]",
            name: "tokenIds",
            type: "uint256[]",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "transmuteId",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "originalType",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "targetType",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "tokenRarity",
            type: "uint256",
          },
          {
            indexed: false,
            internalType: "uint256",
            name: "averageExperience",
            type: "uint256",
          },
        ],
        correctLogs.data,
        ["0xd7eaad220666ecc923d59708f4957538e7c552dce8abf6c8ab6f833e558b892c"]
      );
      return { status: "success", tokenTransmute: parseInt(transaction.transmuteId) };
    }
  }
  throw new Error("Event not found");
}

export default {
  ABI,
  ADDRESS: NFT_TRANSMUTATION_ADDRESS,
  getTransmuteFee,
  transmute,
  getForgingLengthOfOwner,
  getForgingIdOfOwnerAtIndex,
  getRemainingTime,
  claimTransmute,
};
